<template>
	<div class="tab-pane-stat-wrapper">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>
		
		
		<!-- выбор периода для мониторинга -->
		<h3 style="margin-bottom:0">{{ 'main/monitoring' | ftc }}</h3>
		<div class="w5-form-row">
			<Field
				v-if="monField"
				:isVisibleRow="true"
				crud="vds"
				action="view"
				v-model="monValue"
				:Field="monField"
				@valueChanged="monFieldChanged"
				:removeRightPadding="true" />
		</div>

		<!-- график по мониторингу - CPU -->
		<div class="w5-view-vds-stat-graph-wrapper" style="margin-top: 20px">
			<h5 style="margin-left: 20px">{{ 'service/stat_block_cpu' | ftc }}</h5>
			<div class="w5-view-vds-stat-traf-graph">
				<chartLine v-if="cacheData['mon']['cpu']" :data="cacheData['mon']['cpu']" :options="lineChartOptionsCpu" class="w5-chart-graph" style="height: 200px" />
				<img v-else-if="cacheData['mon']['cpu'] === false" src="../../assets/img/loading16.gif" />
				<div v-else-if="cacheData['mon']['cpu'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'service/stat_empty' | ftc }}</div>
			</div>
		</div>

		<!-- график по мониторингу - DISK -->
		<div class="w5-view-vds-stat-graph-wrapper" style="margin-top: 30px">
			<h5 style="margin-left: 20px">{{ 'service/stat_block_disk' | ftc }}</h5>
			<div class="w5-view-vds-stat-traf-graph">
				<chartLine v-if="cacheData['mon']['disk']" :data="cacheData['mon']['disk']" :options="lineChartOptionsDisk" class="w5-chart-graph" style="height: 200px" />
				<img v-else-if="cacheData['mon']['disk'] === false" src="../../assets/img/loading16.gif" />
				<div v-else-if="cacheData['mon']['disk'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'service/stat_empty' | ftc }}</div>
			</div>
		</div>

		<!-- график по мониторингу - traf -->
		<div class="w5-view-vds-stat-graph-wrapper" style="margin-top: 30px">
			<h5 style="margin-left: 20px">{{ 'service/stat_block_vnet' | ftc }}</h5>
			<div class="w5-view-vds-stat-traf-graph">
				<chartLine v-if="cacheData['mon']['traf']" :data="cacheData['mon']['traf']" :options="lineChartOptionsTraf" class="w5-chart-graph" style="height: 200px" />
				<img v-else-if="cacheData['mon']['traf'] === false" src="../../assets/img/loading16.gif" />
				<div v-else-if="cacheData['mon']['traf'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'service/stat_empty' | ftc }}</div>
			</div>
		</div>

		<!-- график по мониторингу - trafLocal -->
		<div v-if="localIpInfo && typeof localIpInfo === 'object' && localIpInfo.ip" class="w5-view-vds-stat-graph-wrapper" style="margin-top: 30px">
			<h5 style="margin-left: 20px">{{ 'service/stat_block_lnet' | ftc }}</h5>
			<div class="w5-view-vds-stat-traf-graph">
				<chartLine v-if="cacheData['mon']['trafLocal']" :data="cacheData['mon']['trafLocal']" :options="lineChartOptionsTrafLocal" class="w5-chart-graph" style="height: 200px" />
				<img v-else-if="cacheData['mon']['trafLocal'] === false" src="../../assets/img/loading16.gif" />
				<div v-else-if="cacheData['mon']['trafLocal'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'service/stat_empty' | ftc }}</div>
			</div>
		</div>




		<!-- выбор периода для трафика -->
		<h3 style="margin-bottom: 0; margin-top: 60px;">{{ 'service/stat_monthly_bandwidth' | ftc }}</h3>
		<div class="w5-form-row">
			<Field
				v-if="trafField"
				:isVisibleRow="true"
				crud="vds"
				action="view"
				v-model="trafValue"
				:Field="trafField"
				@valueChanged="trafFieldChanged"
				:removeRightPadding="true" />
		</div>

		<!-- сводная таблица -->
		<div class="w5-view-vds-stat-traf-table">
			<div class="w5-view-vds-stat-traf-table-header">{{ 'main/usage' | ftc }}:</div>

			<div v-if="cacheData['traf']['usage']" class="w5-view-vds-stat-traf-table-value">{{ cacheData['traf']['usage'] }}</div>
			<img v-else-if="cacheData['traf']['usage'] === false" src="../../assets/img/loading16.gif" />
			<div v-else-if="cacheData['traf']['usage'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'main/no_data' | ftc }}</div>
		</div>
		<div class="w5-view-vds-stat-traf-table">
			<div class="w5-view-vds-stat-traf-table-header">{{ 'service/stat_vnet_rx' | ftc }}:</div>

			<div v-if="cacheData['traf']['rx']" class="w5-view-vds-stat-traf-table-value">{{ cacheData['traf']['rx'] }}</div>
			<img v-else-if="cacheData['traf']['rx'] === false" src="../../assets/img/loading16.gif" />
			<div v-else-if="cacheData['traf']['rx'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'main/no_data' | ftc }}</div>
		</div>
		<div class="w5-view-vds-stat-traf-table">
			<div class="w5-view-vds-stat-traf-table-header">{{ 'service/stat_vnet_tx' | ftc }}:</div>

			<div v-if="cacheData['traf']['tx']" class="w5-view-vds-stat-traf-table-value">{{ cacheData['traf']['tx'] }}</div>
			<img v-else-if="cacheData['traf']['tx'] === false" src="../../assets/img/loading16.gif" />
			<div v-else-if="cacheData['traf']['tx'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'main/no_data' | ftc }}</div>
		</div>

		<!-- график по трафику -->
		<div class="w5-view-vds-stat-graph-wrapper" style="margin-top: 10px">
			<div class="w5-view-vds-stat-traf-graph">
				<chartBar v-if="cacheData['traf']['data']" :data="cacheData['traf']['data']" :options="barChartOptions" class="w5-chart-graph" style="height: 200px" />
				<img v-else-if="cacheData['traf']['data'] === false" src="../../assets/img/loading16.gif" />
				<div v-else-if="cacheData['traf']['data'] === null" class="w5-view-vds-stat-traf-table-value"> {{ 'service/stat_empty' | ftc }}</div>
			</div>
		</div>



	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
import chartBar from '@/components/charts/bar'
import chartLine from '@/components/charts/line'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabStat',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'active', 'vdsId', 'planInfo', 'trafInfo', 'localIpInfo'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// преиод по трафику
			trafValue: '1',
			// данные поля
			trafField: {
				type: 'list',
				list: [
					{ 'id': 1, 'name': this.localeFtc('main/current_month') },
					{ 'id': 2, 'name': this.localeFtc('main/last_month') }
				],
				title: 'filter/period',
				_field_name: 'trafPeriod',
				_visible: true,
				_errMsg: ''
			},

			// период по мониторингу
			monValue: '1',
			// данные поля
			monField: {
				type: 'list',
				list: [
					{ 'id': 1, 'name': this.localeFtc('main/today') },
					{ 'id': 2, 'name': this.localeFtc('main/yesterday') },
					{ 'id': 3, 'name': this.localeFtc('filter/period_last_week') },
					{ 'id': 4, 'name': this.localeFtc('main/current_month') },
					{ 'id': 5, 'name': this.localeFtc('main/last_month') }
				],
				title: 'filter/period',
				_field_name: 'monPeriod',
				_visible: true,
				_errMsg: ''
			},

			localErrorMessage: '',

			cacheData: {
				traf: {
					'usage': null,
					'rx': null,
					'tx': null,
					'unit': this.localeFtc('main/traffic_mb'),
					'data': null
				},
				mon: {
					'cpu': null,
					'disk': null,
					'traf': null,
					'trafLocal': null
				}
			},

			// цвета
			Colors: [
				'9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333',
				'999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666',
				'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633',
				'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC',

				'9933FF', '00CCFF', 'CC6600', '00CC00', 'FF3333',
				'999933', '9900CC', 'FFCC99', '666666', 'FF33FF', 'CC3399', 'FF3399', 'CC0066', 'CC6666',
				'CCCC00', '3333CC', 'FF9966', '669933', 'FF6600', 'CC6633', 'FF9900', 'CC9966', '996633',
				'FFCC66', '0066FF', '99CC33', 'CC9900', '6699CC'
			],

			// опции для графика трафика
			barChartOptions: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				'scales': {
					xAxes: [{
						barPercentage: 0.7
					}],
					yAxes: [{
						barPercentage: 0.7,
						ticks: {
							beginAtZero: true
						}
					}]
				},
				'tooltips': {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false
				}
			},

			// опции для графика мониторинга
			lineChartOptionsCpu: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						// заголовок
						title: function(items, data) {
							return data['labelsForToolTip'][items[0]['index']]
						},
						// надпись
						label: function(item, data) {
							let _label = data['datasets'][item.datasetIndex]['label']
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + '%'
						}
					}
				},
				'scales': {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							callback: function(value) {
								let _val = value.toFixed(1)
								let _parts = _val.split('.')
								if (+(_parts && _parts[1])) return _val + '%'
								return _parts[0] + '%'
							}
						}
					}]
				}
			},

			lineChartOptionsDisk: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						// заголовок
						title: function(items, data) {
							return data['labelsForToolTip'][items[0]['index']]
						},
						// надпись
						label: function(item, data) {
							let _label = data['datasets'][item.datasetIndex]['label']
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' iops'
						}
					}
				},
				'scales': {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							callback: function(value) {
								let _val = value.toFixed(1)
								let _parts = _val.split('.')
								if (+(_parts && _parts[1])) return _val + ' iops'
								return _parts[0] + ' iops'
							}
						}
					}]
				}
			},

			lineChartOptionsTraf: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						// заголовок
						title: function(items, data) {
							return data['labelsForToolTip'][items[0]['index']]
						},
						// надпись
						label: function(item, data) {
							let _label = data['datasets'][item.datasetIndex]['label']
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' Мб'
						}
					}
				},
				'scales': {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							callback: function(value) {
								let _val = value.toFixed(1)
								let _parts = _val.split('.')
								if (+(_parts && _parts[1])) return _val + ' Мб'
								return _parts[0] + ' Мб'
							}
						}
					}]
				}
			},

			lineChartOptionsTrafLocal: {
				defaultFontFamily: 'Roboto',
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					titleFontSize: 11,
					bodyFontSize: 11,
					footerFontSize: 11,
					intersect: false,
					mode: 'index',
					callbacks: {
						// заголовок
						title: function(items, data) {
							return data['labelsForToolTip'][items[0]['index']]
						},
						// надпись
						label: function(item, data) {
							let _label = data['datasets'][item.datasetIndex]['label']
							return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' Мб'
						}
					}
				},
				'scales': {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							callback: function(value) {
								let _val = value.toFixed(1)
								let _parts = _val.split('.')
								if (+(_parts && _parts[1])) return _val + ' Мб'
								return _parts[0] + ' Мб'
							}
						}
					}]
				}
			}
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		if (this.active)
		{
			this.trafFieldChanged()
			this.monFieldChanged()
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// выбор периода по трафику
		//---------------------------------------------------------------------
		trafFieldChanged() {
			// готовим переменные
			let dt = {
				'ServiceStatSearch': {}
			}
			let today = new Date()
			let _year = today.getFullYear()
			let _month = today.getMonth()
			let start
			let end

			// если выбран текущий месяц
			if (this.trafValue === '1')
			{
				// текущий месяц
				start = new Date(_year, _month, 1, 0, 0, 0, 0)
				end = new Date(_year, _month, today.getDate(), 23, 59, 59, 0)

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start)
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end)
			}
			// если выбран прошлый месяц
			else
			{
				end = new Date(_year, _month, 0, 23, 59, 59, 0)
				// прошлый месяц
				_month--
				// если это был январь - перелестнем и год
				if (_month < 0)
				{
					_month = 11
					_year--
				}
				start = new Date(_year, _month, 1, 0, 0, 0, 0)

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start)
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end)
			}

			this.getTrafData(dt)
		},
		//---------------------------------------------------------------------
		// запрос данных по трафику
		//---------------------------------------------------------------------
		getTrafData(dates) {
			// обнуляем данные - с показом спинеров
			this.cacheData['traf']['usage'] = false
			this.cacheData['traf']['rx'] = false
			this.cacheData['traf']['tx'] = false
			this.cacheData['traf']['data'] = false

			// не нужно показывать лоадер
			this.$store.commit('needShowLoader', false)
			// делаем запрос
			let _url = this.APIServerUrl + '/service/stat/' + this.vdsId
			this.$http.get(_url, { 'params': dates }).then(
				// успешный ответ сервера
				res => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'ok' && _dt['rows'])
					{
						// генерация графика
						this.compileTrafData(_dt)
						return
					}

					// нет данных
					this.cacheData['traf']['usage'] = null
					this.cacheData['traf']['rx'] = null
					this.cacheData['traf']['tx'] = null
					this.cacheData['traf']['data'] = null

					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				},
				// отрицательный ответ сервера
				res => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// нет данных
					this.cacheData['traf']['usage'] = null
					this.cacheData['traf']['rx'] = null
					this.cacheData['traf']['tx'] = null
					this.cacheData['traf']['data'] = null

					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				}
			)
		},
		//---------------------------------------------------------------------
		// сбор итоговых данных по трафику
		//---------------------------------------------------------------------
		compileTrafData(data) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// вычислим максимальное значение по трафику,
			// а так же общий трафик в мегабайтах
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let i
			let Y
			let X
			let maxBandWidth = 0
			let unit = this.localeFtc('main/traffic_mb')
			let rows = data.rows
			let vnetRX = 0.0
			let vnetTX = 0.0

			for (i = 0; i < rows.length; i++)
			{
				// значения
				Y = rows[i]['stat_value']
				// если это число больше нашего - то запомним его
				if (Y['vnet_rx'] > maxBandWidth) maxBandWidth = Y['vnet_rx']
				if (Y['vnet_tx'] > maxBandWidth) maxBandWidth = Y['vnet_tx']
				// суммируем в мегабайтах
				vnetRX += Y['vnet_rx'] / 1048576.0
				vnetTX += Y['vnet_tx'] / 1048576.0
			}

			// единицы измерения
			if (maxBandWidth >= 1073741824.0)
			{
				unit = this.localeFtc('main/traffic_gb')
				vnetRX /= 1024.0
				vnetTX /= 1024.0
			}

			this.cacheData['traf']['rx'] = vnetRX.toFixed(2) + ' ' + unit
			this.cacheData['traf']['tx'] = vnetTX.toFixed(2) + ' ' + unit

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// общий трафик берем из vdsView
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.cacheData['traf']['usage'] = null
			if (this.planInfo && this.planInfo['traff'])
			{
				let _trfTxt = this.planInfo['traff']['value']
				let _trfNum = parseInt(_trfTxt, 10)
				_trfTxt += ' ' + this.planInfo['traff']['for']

				// статистика
				if (this.trafInfo && this.trafInfo['current'] && this.trafInfo['last'])
				{
					var _trafikMonth = false
					if (this.trafValue === '1') _trafikMonth = this.trafInfo['current']
					else _trafikMonth = this.trafInfo['last']

					if (_trafikMonth && _trafikMonth['value'] && _trafikMonth['text'])
						this.cacheData['traf']['usage'] = _trafikMonth['value'] + ' ' + this.localeFtc('main/out_of') + ' ' + _trfTxt + ' (' + _trafikMonth['text'] + ')'
					else
						this.cacheData['traf']['usage'] = null
				}
				else
				{
					if (unit.toLowerCase() === 'мб' || unit.toLowerCase() === 'mb') _trfNum *= 1000000.0
					else _trfNum *= 1000.0
					let _prc = vnetTX * 100.0 / _trfNum
					this.cacheData['traf']['usage'] = (vnetTX + vnetTX).toFixed(2) + ' ' + unit + ' ' + this.localeFtc('main/out_of') + ' ' + _trfTxt + ' (' + _prc.toFixed(2) + '%)'
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// собераем данные для графика
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.cacheData['traf']['data'] = null
			let _rxData = {}
			let _txData = {}
			let _tmp
			for (i = 0; i < rows.length; i++)
			{
				// получим день
				_tmp = rows[i]['stat_date']
				if (rows.length <= 24) X = _tmp
				else X = _tmp.substr(0, 10)

				// получим значение
				Y = rows[i]['stat_value']

				// суммируем в мегабайтах RX
				if (_rxData[X]) _rxData[X] += parseFloat(Y['vnet_rx']) / 1048576.0
				else _rxData[X] = parseFloat(Y['vnet_rx']) / 1048576.0

				if (_txData[X]) _txData[X] += parseFloat(Y['vnet_tx']) / 1048576.0
				else _txData[X] = parseFloat(Y['vnet_tx']) / 1048576.0
			}

			// переведем в массив
			let _rxArr = []
			let _txArr = []
			let _labels = []
			let _labelToolTip = []
			for (X in _rxData)
			{
				_labels.push(rows.length <= 24 ? this.formater_StrDateFormat(X) : this.formater_StrDateFormat(X, this.trafValue === '1' ? 'd' : 'd.m'))
				_labelToolTip.push(rows.length <= 24 ? this.formater_StrDateFormat(X) : this.formater_StrDateFormat(X, 'd.m.Y'))
				_rxArr.push((unit.toLowerCase() === 'мб' || unit.toLowerCase() === 'mb' ? _rxData[X] : _rxData[X] / 1024.0).toFixed(2))
				_txArr.push((unit.toLowerCase() === 'мб' || unit.toLowerCase() === 'mb' ? _txData[X] : _txData[X] / 1024.0).toFixed(2))
			}

			this.cacheData['traf']['data'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [
					{
						'borderColor': '#' + this.Colors[0],
						'backgroundColor': '#' + this.Colors[0],
						'data': _rxArr,
						'label': this.localeFtc('service/stat_vnet_rx')
					},
					{
						'borderColor': '#' + this.Colors[1],
						'backgroundColor': '#' + this.Colors[1],
						'data': _txArr,
						'label': this.localeFtc('service/stat_vnet_tx')
					}
				]
			}

			// поставим единицу измерения на ось Y
			this.barChartOptions['scales']['yAxes'][0]['ticks']['callback'] = function(value) {
				let _val = value.toFixed(1)
				let _parts = _val.split('.')
				if (+(_parts && _parts[1])) return _val + ' ' + unit
				return _parts[0] + ' ' + unit
			}
			this.barChartOptions['tooltips']['callbacks'] = {
				// заголовок
				title: function(items, data) {
					return data['labelsForToolTip'][items[0]['index']]
				},
				// надпись
				label: function(item, data) {
					let _label = data['datasets'][item.datasetIndex]['label']

					return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' ' + unit
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// выбор периода по мониторингу
		//---------------------------------------------------------------------
		monFieldChanged() {
			// готовим переменные
			let dt = {
				'ServiceStatSearch': {}
			}
			let today = new Date()
			let start
			let end

			// если выбран сегодня - даты не нужны
			if (this.monValue === '1')
			{
				dt = null
			}
			// если выбран вчера
			else if (this.monValue === '2')
			{
				start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0, 0, 0)
				end = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 23, 59, 59, 0)

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start)
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end)
			}
			// если выбран последние 7 дней
			else if (this.monValue === '3')
			{
				start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6, 0, 0, 0, 0)
				end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 0)

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start)
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end)
			}

			// если выбран текущий месяц
			else if (this.monValue === '4')
			{
				start = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0)
				end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 0)

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start)
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end)
			}

			// если выбран прошлый месяц
			else if (this.monValue === '5')
			{
				let _m = today.getMonth() - 1
				let _y = today.getFullYear()
				if (_m < 0)
				{
					_m = 11
					_y--
				}
				start = new Date(_y, _m, 1, 0, 0, 0, 0)
				end = new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 0)

				dt['ServiceStatSearch']['service_date_start'] = this.formater_Date2StrDateTimeAsIs(start)
				dt['ServiceStatSearch']['service_date_end'] = this.formater_Date2StrDateTimeAsIs(end)
			}

			this.getMonData(dt)
		},
		//---------------------------------------------------------------------
		// запрос данных для мониторинга
		//---------------------------------------------------------------------
		getMonData(dates) {
			// обнуляем данные - с показом спинеров
			this.cacheData['mon']['cpu'] = false
			this.cacheData['mon']['disk'] = false
			this.cacheData['mon']['traf'] = false
			this.cacheData['mon']['trafLocal'] = false

			// не нужно показывать лоадер
			this.$store.commit('needShowLoader', false)
			// делаем запрос
			let _url = this.APIServerUrl + '/service/stat/' + this.vdsId
			this.$http.get(_url, { 'params': dates }).then(
				// успешный ответ сервера
				res => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'ok' && _dt['rows'])
					{
						// генерация графика
						this.compileMonData(_dt)
						return
					}

					// нет данных
					this.cacheData['mon']['cpu'] = null
					this.cacheData['mon']['disk'] = null
					this.cacheData['mon']['traf'] = null
					this.cacheData['mon']['trafLocal'] = null

					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				},
				// отрицательный ответ сервера
				res => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// нет данных
					this.cacheData['mon']['cpu'] = null
					this.cacheData['mon']['disk'] = null
					this.cacheData['mon']['traf'] = null
					this.cacheData['mon']['trafLocal'] = null

					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				}
			)
		},
		//---------------------------------------------------------------------
		// сбор итоговых данных по мониторингу
		//---------------------------------------------------------------------
		compileMonData(data) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// вычислим максимальное значение по трафику,
			// а так же общий трафик в мегабайтах
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let i
			let Y
			let X
			let maxBandWidth = 0
			let maxBandWidthLocal = 0
			let unit = 'Kbps'
			let unitLocal = 'Kbps'
			let rows = data.rows

			for (i = 0; i < rows.length; i++)
			{
				// значения
				Y = rows[i]['stat_value']
				// если это число больше нашего - то запомним его
				if (Y['vnet_rx'] > maxBandWidth) maxBandWidth = Y['vnet_rx']
				if (Y['vnet_tx'] > maxBandWidth) maxBandWidth = Y['vnet_tx']

				if (Y['lnet_rx'] > maxBandWidthLocal) maxBandWidthLocal = Y['lnet_rx']
				if (Y['lnet_tx'] > maxBandWidthLocal) maxBandWidthLocal = Y['lnet_tx']
			}

			// единицы измерения
			let _normTraf = (n) => n * 8 / 1024.0 / 3600.0
			let _normTrafLocal = (n) => n * 8 / 1024.0 / 3600.0
			if (maxBandWidth >= 1073741824.0)
			{
				unit = 'Мbps'
				_normTraf = (n) => n * 8 / 1048576.0 / 3600.0
			}

			if ((maxBandWidthLocal / 1024.0) >= 1073741824.0)
			{
				unitLocal = 'Gbps'
				_normTrafLocal = (n) => n * 8 / 1073741824.0 / 3600.0
			}
			else if (maxBandWidthLocal >= 1073741824.0)
			{
				unitLocal = 'Мbps'
				_normTrafLocal = (n) => n * 8 / 1048576.0 / 3600.0
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// собераем данные для графика
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.cacheData['mon']['cpu'] = null
			this.cacheData['mon']['disk'] = null
			this.cacheData['mon']['traf'] = null
			this.cacheData['mon']['trafLocal'] = null

			let _cpuData = {}
			let _diskR = {}
			let _diskW = {}
			let _rxData = {}
			let _txData = {}
			let _rxDataLocal = {}
			let _txDataLocal = {}
			let _tmp
			for (i = 0; i < rows.length; i++)
			{
				// получим день
				X = rows[i]['stat_date']

				// получим значение
				Y = rows[i]['stat_value']

				// CPU
				_cpuData[X] = parseFloat(Y['cpu'])

				// DISK
				_diskR[X] = parseFloat(Y['disk_reads']) / 3600.0
				_diskW[X] = parseFloat(Y['disk_writes']) / 3600.0

				// трафик
				_rxData[X] = _normTraf(parseFloat(Y['vnet_rx']))
				_txData[X] = _normTraf(parseFloat(Y['vnet_tx']))

				// локальный трафик
				_rxDataLocal[X] = _normTrafLocal(parseFloat(Y['lnet_rx']))
				_txDataLocal[X] = _normTrafLocal(parseFloat(Y['lnet_tx']))
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// переведем в массив
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _cpuArr = []
			let _diskRArr = []
			let _diskWArr = []
			let _rxArr = []
			let _txArr = []
			let _rxArrLocal = []
			let _txArrLocal = []
			let _labels = []
			let _labelToolTip = []
			for (X in _cpuData)
			{
				// надписи
				if (this.monValue === '1' || this.monValue === '2') _tmp = this.formater_StrDateFormat(X, 'H:M')
				else _tmp = this.formater_StrDateFormat(X, 'd.m')
				_labels.push(_tmp)

				_labelToolTip.push(this.formater_StrDateFormat(X))

				// данные
				_cpuArr.push(_cpuData[X].toFixed(2))

				_diskRArr.push(_diskR[X].toFixed(2))
				_diskWArr.push(_diskW[X].toFixed(2))

				_rxArr.push(_rxData[X].toFixed(2))
				_txArr.push(_txData[X].toFixed(2))

				_rxArrLocal.push(_rxDataLocal[X].toFixed(2))
				_txArrLocal.push(_txDataLocal[X].toFixed(2))
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// формируем данные для графиков
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.cacheData['mon']['cpu'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[0],
						'backgroundColor': '#' + this.Colors[0],
						'pointBackgroundColor': '#' + this.Colors[0],
						'data': _cpuArr,
						'label': this.localeFtc('service/stat_cpu')
					}
				]
			}

			this.cacheData['mon']['disk'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[0],
						'backgroundColor': '#' + this.Colors[0],
						'pointBackgroundColor': '#' + this.Colors[0],
						'data': _diskRArr,
						'label': this.localeFtc('service/stat_disk_reads')
					},
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[1],
						'backgroundColor': '#' + this.Colors[1],
						'pointBackgroundColor': '#' + this.Colors[1],
						'data': _diskWArr,
						'label': this.localeFtc('service/stat_disk_writes')
					}
				]
			}

			this.cacheData['mon']['traf'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[0],
						'backgroundColor': '#' + this.Colors[0],
						'pointBackgroundColor': '#' + this.Colors[0],
						'data': _rxArr,
						'label': this.localeFtc('service/stat_vnet_rx')
					},
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[1],
						'backgroundColor': '#' + this.Colors[1],
						'pointBackgroundColor': '#' + this.Colors[1],
						'data': _txArr,
						'label': this.localeFtc('service/stat_vnet_tx')
					}
				]
			}

			this.cacheData['mon']['trafLocal'] = {
				'labels': _labels,
				'labelsForToolTip': _labelToolTip,
				'datasets': [
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[0],
						'backgroundColor': '#' + this.Colors[0],
						'pointBackgroundColor': '#' + this.Colors[0],
						'data': _rxArrLocal,
						'label': this.localeFtc('service/stat_lnet_rx')
					},
					{
						'fill': false,
						'pointRadius': this.monValue === '1' || this.monValue === '2' ? 4 : 0.5,
						'lineTension': 0.05,
						'borderWidth': 1,
						'borderColor': '#' + this.Colors[1],
						'backgroundColor': '#' + this.Colors[1],
						'pointBackgroundColor': '#' + this.Colors[1],
						'data': _txArrLocal,
						'label': this.localeFtc('service/stat_lnet_tx')
					}
				]
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// поставим единицу измерения на ось Y для трафика
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.lineChartOptionsTraf['scales']['yAxes'][0]['ticks']['callback'] = function(value) {
				let _val = value.toFixed(1)
				let _parts = _val.split('.')
				if (+(_parts && _parts[1])) return _val + ' ' + unit
				return _parts[0] + ' ' + unit
			}
			this.lineChartOptionsTraf['tooltips']['callbacks'] = {
				// заголовок
				title: function(items, data) {
					return data['labelsForToolTip'][items[0]['index']]
				},
				// надпись
				label: function(item, data) {
					let _label = data['datasets'][item.datasetIndex]['label']
					return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' ' + unit
				}
			}

			this.lineChartOptionsTrafLocal['scales']['yAxes'][0]['ticks']['callback'] = function(value) {
				let _val = value.toFixed(1)
				let _parts = _val.split('.')
				if (+(_parts && _parts[1])) return _val + ' ' + unitLocal
				return _parts[0] + ' ' + unitLocal
			}
			this.lineChartOptionsTrafLocal['tooltips']['callbacks'] = {
				// заголовок
				title: function(items, data) {
					return data['labelsForToolTip'][items[0]['index']]
				},
				// надпись
				label: function(item, data) {
					let _label = data['datasets'][item.datasetIndex]['label']
					return ' ' + _label + ' ' + item.yLabel.toFixed(2) + ' ' + unitLocal
				}
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'active': function(value) {
			if (this.active)
			{
				this.trafFieldChanged()
				this.monFieldChanged()
			}
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field,
		chartBar,
		chartLine
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-view-vds-stat-traf-table {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	align-items: center;
	-webkit-align-items: center;
}

.w5-view-vds-stat-traf-table-header {
	width: 160px;
}
.w5-view-vds-stat-traf-table-value {
	font-weight: 500;
}

.w5-view-vds-stat-graph-wrapper {
	border: 1px solid #eee;
	border-radius: 4px;
}

.w5-view-vds-stat-traf-graph {
	margin: 10px;
	text-align: center;
	height: 210px;
}

.w5-view-vds-stat-traf-graph img {
	margin-top: 97px;
}

.w5-view-vds-stat-traf-graph div.w5-view-vds-stat-traf-table-value {
	line-height: 210px;
}

@media (max-width: 767px) {
	.w5-view-vds-stat-traf-table {
		flex-direction: column;
	}
	.w5-view-vds-stat-traf-table-header {
		width: 100%;
	}
	.w5-view-vds-stat-traf-table-value {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// stat.vue?60cd420b